import { Sparkles } from 'lucide-react'

export function AuthShell({
  title,
  subtitle,
  children,
}: {
  title: string
  subtitle?: string
  children: React.ReactNode
}) {
  return (
    <div className="grid min-h-full place-items-center p-4">
      <div className="w-full max-w-md space-y-6">
        <div className="flex flex-col items-center gap-3 text-center">
          <div
            className="flex h-14 w-14 items-center justify-center rounded-2xl text-white shadow-glass ring-1 ring-[#d4af37]/40"
            style={{ background: 'linear-gradient(135deg, #012269, #1f3d99)' }}
          >
            <Sparkles className="h-7 w-7" />
          </div>
          <div>
            <h1 className="text-xl font-semibold tracking-tight">
              TEXA <span className="text-gold">HUB</span>
            </h1>
            <p className="text-sm text-muted-foreground">Gestão de conteúdo e campanhas</p>
          </div>
        </div>

        <div className="glass rounded-3xl p-6 shadow-glass-lg">
          <div className="mb-5 space-y-1">
            <h2 className="text-lg font-semibold">{title}</h2>
            {subtitle && <p className="text-sm text-muted-foreground">{subtitle}</p>}
          </div>
          {children}
        </div>
      </div>
    </div>
  )
}
